import { FC } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  AlertTitle,
  Fade,
} from '@chakra-ui/react';

type FailedProps = AlertProps & {
  title: string;
  description?: string;
};

const defaultDescription =
  'Please contact the technical support team for further assistance';

export const Failed: FC<FailedProps> = ({
  title,
  description = defaultDescription,
  ...props
}) => {
  return (
    <Fade
      in
      transition={{
        enter: { duration: 0.4 },
        exit: { duration: 0.4 },
      }}
    >
      <Alert
        status="error"
        p={0}
        color="red.600"
        background="none"
        data-testid="failed-message"
        {...props}
      >
        <AlertIcon />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription pl={2}>{description}</AlertDescription>
      </Alert>
    </Fade>
  );
};
